export const version = '2.10.0';
export const buildDate = '2025-11-17T15:29:05.414Z';
export const commitHash = '7d5c6de6d';
